import React from "react";
import { Text, View, Image, StyleSheet } from "@react-pdf/renderer";
import {
  DEFAULT_COMPANY,
  formatAmountInWords,
  formatIndianNumber,
  buildHsnGroups,
  deriveTaxRates,
} from "../../utils/pdfDocumentUtils";

export const arPdfStyles = StyleSheet.create({
  page: {
    fontSize: 10,
    padding: 10,
    paddingBottom: 40,
    color: "#000000",
  },
  viewer: {
    width: "100%",
    height: "90vh",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 10,
    bottom: 15,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "#666666",
  },
  docTitle: {
    fontSize: 22,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 2,
    padding: 6,
    backgroundColor: "#ffffff",
  },
  subtitle: {
    fontSize: 9,
    textAlign: "center",
    marginBottom: 2,
  },
  recipient: {
    fontSize: 10,
    textAlign: "center",
    marginBottom: 8,
  },
  mainHeaderSection: {
    flexDirection: "row",
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    marginBottom: 3,
  },
  leftHalfSection: {
    width: "50%",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
    backgroundColor: "#ffffff",
  },
  logoCompanySection: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
    backgroundColor: "#ffffff",
  },
  logoSection: {
    width: "30%",
    padding: 6,
    alignItems: "center",
    justifyContent: "center",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
  },
  logoImage: {
    width: 50,
    height: 50,
  },
  logoPlaceholder: {
    width: 50,
    height: 50,
    backgroundColor: "#f8f8f8",
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 1,
    borderColor: "#ddd",
    borderStyle: "solid",
  },
  logoText: {
    fontSize: 7,
    color: "#666",
    textAlign: "center",
  },
  companySection: {
    width: "70%",
    backgroundColor: "#ffffff",
  },
  companyName: {
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "left",
    padding: 6,
    backgroundColor: "#f8f8f8",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
  },
  companyDetails: {
    fontSize: 9,
    lineHeight: 1.3,
    padding: 6,
  },
  companyDetailLine: {
    marginBottom: 2,
  },
  buyerSection: {
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    marginBottom: 3,
    backgroundColor: "#ffffff",
  },
  siteLocationSection: {
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    marginBottom: 3,
    backgroundColor: "#ffffff",
  },
  buyerHeader: {
    backgroundColor: "#f5f5f5",
    padding: 6,
    fontSize: 11,
    fontWeight: "bold",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
    textAlign: "left",
  },
  buyerContent: {
    padding: 8,
    fontSize: 9,
    lineHeight: 1.4,
  },
  buyerLine: {
    marginBottom: 2,
  },
  boldText: {
    fontWeight: "bold",
  },
  rightHalfSection: {
    width: "50%",
    backgroundColor: "#ffffff",
  },
  invoiceDetailsBlock: {
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
    padding: 6,
  },
  detailRow: {
    flexDirection: "row",
    marginBottom: 2,
  },
  detailLabel: {
    width: "50%",
    fontSize: 10,
    fontWeight: "bold",
    textAlign: "left",
  },
  detailValue: {
    width: "50%",
    fontSize: 9,
    textAlign: "left",
  },
  remarksSection: {
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    marginBottom: 3,
    padding: 8,
    backgroundColor: "#fffbf0",
  },
  remarksText: {
    fontSize: 10,
    lineHeight: 1.3,
  },
  remarksHeader: {
    fontSize: 11,
    fontWeight: "bold",
  },
  servicesTable: {
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    marginBottom: 3,
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#f5f5f5",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
    alignItems: "stretch",
  },
  headerCellContainer: {
    justifyContent: "center",
    alignItems: "center",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
    padding: 4,
  },
  headerCellText: {
    fontWeight: "bold",
    fontSize: 9,
    textAlign: "center",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
    backgroundColor: "#ffffff",
    alignItems: "stretch",
  },
  tableCellContainer: {
    justifyContent: "flex-start",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
    padding: 4,
  },
  tableCellText: {
    fontSize: 8,
  },
  tableCellLeft: {
    textAlign: "left",
  },
  tableCellRight: {
    textAlign: "right",
  },
  serviceDescriptionText: {
    textAlign: "left",
    lineHeight: 1.3,
  },
  itemRemarksText: {
    fontSize: 7,
    color: "#666",
    marginTop: 4,
    fontStyle: "italic",
  },
  totalRow: {
    flexDirection: "row",
    backgroundColor: "#e6e6e6",
    borderBottomWidth: 0,
    alignItems: "stretch",
  },
  totalCellContainer: {
    justifyContent: "center",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
    padding: 4,
  },
  totalCellText: {
    fontWeight: "bold",
    fontSize: 10,
  },
  amountSection: {
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    marginBottom: 3,
    padding: 8,
    backgroundColor: "#f9f9f9",
  },
  amountHeader: {
    fontSize: 11,
    fontWeight: "bold",
    marginBottom: 4,
  },
  amountValue: {
    fontSize: 10,
    lineHeight: 1.3,
  },
  hsnTable: {
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    marginBottom: 3,
  },
  hsnHeader: {
    flexDirection: "row",
    backgroundColor: "#f5f5f5",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
    alignItems: "stretch",
  },
  hsnRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
    backgroundColor: "#ffffff",
    alignItems: "stretch",
  },
  hsnTotalRow: {
    flexDirection: "row",
    backgroundColor: "#e6e6e6",
    fontWeight: "bold",
    alignItems: "stretch",
  },
  hsnCellContainer: {
    padding: 5,
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
    justifyContent: "center",
    alignItems: "center",
  },
  hsnCellText: {
    fontSize: 9,
    textAlign: "center",
  },
  hsnCellTextRight: {
    textAlign: "right",
  },
  hsnCellContainerNoBorder: {
    borderRightWidth: 0,
  },
  bottomSection: {
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    marginBottom: 4,
  },
  bankSection: {
    backgroundColor: "#ffffff",
  },
  bankHeader: {
    backgroundColor: "#f5f5f5",
    padding: 6,
    fontSize: 11,
    fontWeight: "bold",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
  },
  bankRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
  },
  bankRowNoBorder: {
    flexDirection: "row",
  },
  bankLabel: {
    width: "45%",
    padding: 5,
    fontSize: 10,
    fontWeight: "bold",
    backgroundColor: "#f9f9f9",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
    textAlign: "left",
  },
  bankValue: {
    width: "55%",
    padding: 5,
    fontSize: 10,
    textAlign: "left",
  },
  gstNote: {
    fontSize: 9,
    padding: 8,
    lineHeight: 1.3,
  },
  signatureSection: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: 6,
    marginBottom: 10,
  },
  signatureBox: {
    width: "40%",
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    padding: 8,
    backgroundColor: "#ffffff",
    justifyContent: "space-between",
    minHeight: 60,
  },
  signatureText: {
    fontSize: 10,
    fontWeight: "bold",
    textAlign: "right",
    marginBottom: 8,
  },
  footerText: {
    textAlign: "center",
    marginTop: 8,
    marginBottom: 15,
    fontSize: 9,
    fontStyle: "italic",
    color: "#666666",
  },
});

const COL_WIDTHS = {
  description: "22%",
  hsn: "7%",
  charges: "9%",
  qtyUnitRateAmount: "13%",
  cgst: "11%",
  sgst: "11%",
  igst: "9%",
  total: "18%",
};

const resolveCompanyName = (company) =>
  company?.company_name ||
  company?.companyName ||
  company?.name ||
  DEFAULT_COMPANY.name;

export const ArDocumentTitle = ({ title, subtitle, recipientLabel = "Original for Recipient" }) => (
  <>
    <Text style={arPdfStyles.docTitle}>{title}</Text>
    {subtitle ? <Text style={arPdfStyles.subtitle}>{subtitle}</Text> : null}
    <Text style={arPdfStyles.recipient}>{recipientLabel}</Text>
  </>
);

export const ArDocumentHeader = ({ company, logoSource, detailRows = [] }) => {
  const co = company || DEFAULT_COMPANY;

  return (
    <View style={arPdfStyles.mainHeaderSection}>
      <View style={arPdfStyles.leftHalfSection}>
        <View style={arPdfStyles.logoCompanySection}>
          <View style={arPdfStyles.logoSection}>
            {logoSource ? (
              <Image style={arPdfStyles.logoImage} src={logoSource} cache={false} />
            ) : (
              <View style={arPdfStyles.logoPlaceholder}>
                <Text style={arPdfStyles.logoText}>Company{"\n"}Logo</Text>
              </View>
            )}
          </View>
          <View style={arPdfStyles.companySection}>
            <Text style={arPdfStyles.companyName}>{resolveCompanyName(co)}</Text>
            <View style={arPdfStyles.companyDetails}>
              {(co.address || DEFAULT_COMPANY.address) && (
                <Text style={arPdfStyles.companyDetailLine}>{co.address || DEFAULT_COMPANY.address}</Text>
              )}
              {(co.cin || DEFAULT_COMPANY.cin) && (
                <Text style={arPdfStyles.companyDetailLine}>CIN: {co.cin || DEFAULT_COMPANY.cin}</Text>
              )}
              {(co.udyam_no || co.udyamNo || DEFAULT_COMPANY.udyam_no) && (
                <Text style={arPdfStyles.companyDetailLine}>
                  UDYAM No. {co.udyam_no || co.udyamNo || DEFAULT_COMPANY.udyam_no}
                </Text>
              )}
              {(co.gstin || DEFAULT_COMPANY.gstin) && (
                <Text style={arPdfStyles.companyDetailLine}>GSTIN/UIN: {co.gstin || DEFAULT_COMPANY.gstin}</Text>
              )}
              <Text style={arPdfStyles.companyDetailLine}>
                State Name: {co.state_name || co.stateName || co.state || DEFAULT_COMPANY.state}, Code:{" "}
                {co.state_code || co.stateCode || DEFAULT_COMPANY.state_code}
              </Text>
              {(co.email_address || co.emailAddress || co.email || DEFAULT_COMPANY.email) && (
                <Text style={arPdfStyles.companyDetailLine}>
                  E-Mail: {co.email_address || co.emailAddress || co.email || DEFAULT_COMPANY.email}
                </Text>
              )}
            </View>
          </View>
        </View>
      </View>

      <View style={arPdfStyles.rightHalfSection}>
        <View style={arPdfStyles.invoiceDetailsBlock}>
          {detailRows.map((row, index) =>
            row?.value ? (
              <View style={arPdfStyles.detailRow} key={`${row.label}-${index}`}>
                <Text style={arPdfStyles.detailLabel}>{row.label}</Text>
                <Text style={arPdfStyles.detailValue}>{row.value}</Text>
              </View>
            ) : null
          )}
        </View>
      </View>
    </View>
  );
};

export const ArBuyerSiteSection = ({
  customer = {},
  site = {},
  project = {},
  placeOfSupply,
  stateCode,
}) => {
  const supply = placeOfSupply || site?.state_name || customer?.state_name || "MAHARASHTRA";
  const code = stateCode || customer?.state_code || customer?.state_id || "27";

  return (
    <View style={{ flexDirection: "row" }}>
      <View style={[arPdfStyles.buyerSection, { width: "50%", marginRight: 3 }]}>
        <Text style={arPdfStyles.buyerHeader}>Details of Receiver (Billed To)</Text>
        <View style={arPdfStyles.buyerContent}>
          {customer?.name && <Text style={[arPdfStyles.buyerLine, arPdfStyles.boldText]}>{customer.name}</Text>}
          {(customer?.address || site?.site_address) && (
            <Text style={arPdfStyles.buyerLine}>{customer?.address || site?.site_address}</Text>
          )}
          <Text style={arPdfStyles.buyerLine}>GSTIN/UIN: {customer?.gstin || customer?.gst_no || "Unregistered GST"}</Text>
          {(customer?.state_name || customer?.state_code || customer?.state_id) && (
            <Text style={arPdfStyles.buyerLine}>
              State Name: {customer?.state_name || "N/A"}, Code: {customer?.state_code || customer?.state_id || "N/A"}
            </Text>
          )}
        </View>
      </View>

      <View style={[arPdfStyles.siteLocationSection, { width: "50%" }]}>
        <Text style={arPdfStyles.buyerHeader}>Details of Site Location</Text>
        <View style={arPdfStyles.buyerContent}>
          {(project?.project_name || site?.site_name || customer?.name) && (
            <Text style={[arPdfStyles.buyerLine, arPdfStyles.boldText]}>
              {project?.project_name || site?.site_name || customer?.name}
            </Text>
          )}
          {(site?.site_address || project?.address || customer?.address) && (
            <Text style={arPdfStyles.buyerLine}>{site?.site_address || project?.address || customer?.address}</Text>
          )}
          <Text style={arPdfStyles.buyerLine}>
            Place of Supply: {supply} State Code: {code}
          </Text>
        </View>
      </View>
    </View>
  );
};

const formatTaxCell = (rate, amount) => {
  const value = parseFloat(amount) || 0;
  if (value === 0) return "-";
  return `${rate}%\n${formatIndianNumber(value)}`;
};

export const ArServicesTable = ({
  lineItems = [],
  doc = {},
  descriptionHeader = "Asset Name with Model, Make,\nRegistration Number and Serial Number",
}) => {
  const enhancedItems = lineItems.map((item) => {
    if (item.cgstAmt !== undefined) return item;
    const taxable = parseFloat(item.taxable_amount ?? item.amount) || 0;
    return {
      ...item,
      taxable_amount: taxable,
      cgstAmt: 0,
      sgstAmt: 0,
      igstAmt: 0,
      itemTotal: taxable,
    };
  });

  const totalTaxable = enhancedItems.reduce((sum, item) => sum + (parseFloat(item.taxable_amount) || 0), 0);
  const totCgst = enhancedItems.reduce((sum, item) => sum + (parseFloat(item.cgstAmt) || 0), 0);
  const totSgst = enhancedItems.reduce((sum, item) => sum + (parseFloat(item.sgstAmt) || 0), 0);
  const totIgst = enhancedItems.reduce((sum, item) => sum + (parseFloat(item.igstAmt) || 0), 0);
  const grandTotal =
    parseFloat(doc.total_amount) ||
    enhancedItems.reduce((sum, item) => sum + (parseFloat(item.itemTotal) || 0), 0) ||
    totalTaxable + totCgst + totSgst + totIgst;

  const { cgstSgstRate, igstRate } = deriveTaxRates(doc, enhancedItems);

  return (
    <View style={arPdfStyles.servicesTable}>
      <View style={arPdfStyles.tableHeader}>
        <View style={[arPdfStyles.headerCellContainer, { width: COL_WIDTHS.description }]}>
          <Text style={arPdfStyles.headerCellText}>{descriptionHeader}</Text>
        </View>
        <View style={[arPdfStyles.headerCellContainer, { width: COL_WIDTHS.hsn }]}>
          <Text style={arPdfStyles.headerCellText}>HSN Code</Text>
        </View>
        <View style={[arPdfStyles.headerCellContainer, { width: COL_WIDTHS.charges }]}>
          <Text style={arPdfStyles.headerCellText}>Charges</Text>
        </View>
        <View style={[arPdfStyles.headerCellContainer, { width: COL_WIDTHS.qtyUnitRateAmount }]}>
          <Text style={arPdfStyles.headerCellText}>Quantity{"\n"}Unit{"\n"}Rate{"\n"}Amount</Text>
        </View>
        <View style={[arPdfStyles.headerCellContainer, { width: COL_WIDTHS.cgst }]}>
          <Text style={arPdfStyles.headerCellText}>CGST{"\n"}%{"\n"}Amount</Text>
        </View>
        <View style={[arPdfStyles.headerCellContainer, { width: COL_WIDTHS.sgst }]}>
          <Text style={arPdfStyles.headerCellText}>SGST{"\n"}%{"\n"}Amount</Text>
        </View>
        <View style={[arPdfStyles.headerCellContainer, { width: COL_WIDTHS.igst }]}>
          <Text style={arPdfStyles.headerCellText}>IGST{"\n"}%{"\n"}Amount</Text>
        </View>
        <View style={[arPdfStyles.headerCellContainer, { width: COL_WIDTHS.total, borderRightWidth: 0 }]}>
          <Text style={arPdfStyles.headerCellText}>Total Amount</Text>
        </View>
      </View>

      {enhancedItems.map((item, index) => {
        const taxable = parseFloat(item.taxable_amount) || 0;
        const qty = item.quantity != null ? parseFloat(item.quantity).toFixed(3) : "1.000";
        const unit = item.unit || "NOS";
        const rate = item.rate != null ? formatIndianNumber(item.rate) : formatIndianNumber(taxable);
        const quantityUnitRateAmount = `${qty}\n${unit}\n${rate}\n${formatIndianNumber(taxable)}`;

        return (
          <View style={arPdfStyles.tableRow} key={index}>
            <View style={[arPdfStyles.tableCellContainer, { width: COL_WIDTHS.description }]}>
              <Text style={[arPdfStyles.tableCellText, arPdfStyles.serviceDescriptionText]}>
                {item.description || "N/A"}
              </Text>
              {item.remarks ? (
                <Text style={arPdfStyles.itemRemarksText}>Remarks: {item.remarks}</Text>
              ) : null}
            </View>
            <View style={[arPdfStyles.tableCellContainer, { width: COL_WIDTHS.hsn }]}>
              <Text style={[arPdfStyles.tableCellText, arPdfStyles.tableCellRight]}>
                {item.hsn_code || item.hsn_sac || "997319"}
              </Text>
            </View>
            <View style={[arPdfStyles.tableCellContainer, { width: COL_WIDTHS.charges }]}>
              <Text style={[arPdfStyles.tableCellText, arPdfStyles.tableCellRight]}>
                {formatIndianNumber(taxable)}
              </Text>
            </View>
            <View style={[arPdfStyles.tableCellContainer, { width: COL_WIDTHS.qtyUnitRateAmount }]}>
              <Text style={[arPdfStyles.tableCellText, arPdfStyles.tableCellRight]}>{quantityUnitRateAmount}</Text>
            </View>
            <View style={[arPdfStyles.tableCellContainer, { width: COL_WIDTHS.cgst }]}>
              <Text style={[arPdfStyles.tableCellText, arPdfStyles.tableCellRight]}>
                {formatTaxCell(cgstSgstRate, item.cgstAmt)}
              </Text>
            </View>
            <View style={[arPdfStyles.tableCellContainer, { width: COL_WIDTHS.sgst }]}>
              <Text style={[arPdfStyles.tableCellText, arPdfStyles.tableCellRight]}>
                {formatTaxCell(cgstSgstRate, item.sgstAmt)}
              </Text>
            </View>
            <View style={[arPdfStyles.tableCellContainer, { width: COL_WIDTHS.igst }]}>
              <Text style={[arPdfStyles.tableCellText, arPdfStyles.tableCellRight]}>
                {formatTaxCell(igstRate, item.igstAmt)}
              </Text>
            </View>
            <View style={[arPdfStyles.tableCellContainer, { width: COL_WIDTHS.total, borderRightWidth: 0 }]}>
              <Text style={[arPdfStyles.tableCellText, arPdfStyles.tableCellRight]}>
                {formatIndianNumber(item.itemTotal ?? taxable)}
              </Text>
            </View>
          </View>
        );
      })}

      <View style={arPdfStyles.totalRow}>
        <View style={[arPdfStyles.totalCellContainer, { width: COL_WIDTHS.description }]}>
          <Text style={[arPdfStyles.totalCellText, arPdfStyles.tableCellLeft]}>Total Rs. :</Text>
        </View>
        <View style={[arPdfStyles.totalCellContainer, { width: COL_WIDTHS.hsn }]}>
          <Text style={[arPdfStyles.totalCellText, arPdfStyles.tableCellRight]}>-</Text>
        </View>
        <View style={[arPdfStyles.totalCellContainer, { width: COL_WIDTHS.charges }]}>
          <Text style={[arPdfStyles.totalCellText, arPdfStyles.tableCellRight]}>-</Text>
        </View>
        <View style={[arPdfStyles.totalCellContainer, { width: COL_WIDTHS.qtyUnitRateAmount }]}>
          <Text style={[arPdfStyles.totalCellText, arPdfStyles.tableCellRight]}>
            {formatIndianNumber(totalTaxable)}
          </Text>
        </View>
        <View style={[arPdfStyles.totalCellContainer, { width: COL_WIDTHS.cgst }]}>
          <Text style={[arPdfStyles.totalCellText, arPdfStyles.tableCellRight]}>
            {totCgst !== 0 ? formatIndianNumber(totCgst) : "-"}
          </Text>
        </View>
        <View style={[arPdfStyles.totalCellContainer, { width: COL_WIDTHS.sgst }]}>
          <Text style={[arPdfStyles.totalCellText, arPdfStyles.tableCellRight]}>
            {totSgst !== 0 ? formatIndianNumber(totSgst) : "-"}
          </Text>
        </View>
        <View style={[arPdfStyles.totalCellContainer, { width: COL_WIDTHS.igst }]}>
          <Text style={[arPdfStyles.totalCellText, arPdfStyles.tableCellRight]}>
            {totIgst !== 0 ? formatIndianNumber(totIgst) : "-"}
          </Text>
        </View>
        <View style={[arPdfStyles.totalCellContainer, { width: COL_WIDTHS.total, borderRightWidth: 0 }]}>
          <Text style={[arPdfStyles.totalCellText, arPdfStyles.tableCellRight]}>
            {formatIndianNumber(Math.round(grandTotal))}
          </Text>
        </View>
      </View>
    </View>
  );
};

export const ArAmountInWords = ({ amount, wordsOverride }) => {
  const words = wordsOverride
    ? wordsOverride.replace(/^Rupees\s+/i, "").replace(/\sOnly\s*$/i, "").trim()
    : formatAmountInWords(Math.round(parseFloat(amount) || 0));

  return (
    <View style={arPdfStyles.amountSection} wrap={false}>
      <Text style={arPdfStyles.amountHeader}>Amount in Words:</Text>
      <Text style={arPdfStyles.amountValue}>Rupees {words} Only</Text>
    </View>
  );
};

export const ArHsnSummaryTable = ({ enhancedItems = [], doc = {}, showWhenEmpty = true }) => {
  const hsnGroups = buildHsnGroups(enhancedItems);
  const entries = Object.entries(hsnGroups);
  if (!showWhenEmpty && entries.length === 0) return null;

  const totalTaxable = enhancedItems.reduce((sum, item) => sum + (parseFloat(item.taxable_amount) || 0), 0);
  const totCgst = enhancedItems.reduce((sum, item) => sum + (parseFloat(item.cgstAmt) || 0), 0);
  const totSgst = enhancedItems.reduce((sum, item) => sum + (parseFloat(item.sgstAmt) || 0), 0);
  const totIgst = enhancedItems.reduce((sum, item) => sum + (parseFloat(item.igstAmt) || 0), 0);
  const { cgstSgstRate, igstRate } = deriveTaxRates(doc, enhancedItems);

  const displayEntries = entries.length > 0 ? entries : [["-", { taxable: totalTaxable, cgst: 0, sgst: 0, igst: 0 }]];

  return (
    <View style={arPdfStyles.hsnTable} wrap={false}>
      <View style={arPdfStyles.hsnHeader}>
        <View style={[arPdfStyles.hsnCellContainer, { width: "15%" }]}>
          <Text style={arPdfStyles.hsnCellText}>HSN/SAC</Text>
        </View>
        <View style={[arPdfStyles.hsnCellContainer, { width: "17%" }]}>
          <Text style={arPdfStyles.hsnCellText}>Taxable{"\n"}Value</Text>
        </View>
        <View style={[arPdfStyles.hsnCellContainer, { width: "10%" }]}>
          <Text style={arPdfStyles.hsnCellText}>CGST{"\n"}Rate</Text>
        </View>
        <View style={[arPdfStyles.hsnCellContainer, { width: "12%" }]}>
          <Text style={arPdfStyles.hsnCellText}>CGST{"\n"}Amount</Text>
        </View>
        <View style={[arPdfStyles.hsnCellContainer, { width: "10%" }]}>
          <Text style={arPdfStyles.hsnCellText}>SGST{"\n"}Rate</Text>
        </View>
        <View style={[arPdfStyles.hsnCellContainer, { width: "12%" }]}>
          <Text style={arPdfStyles.hsnCellText}>SGST{"\n"}Amount</Text>
        </View>
        <View style={[arPdfStyles.hsnCellContainer, { width: "10%" }]}>
          <Text style={arPdfStyles.hsnCellText}>IGST{"\n"}Rate</Text>
        </View>
        <View style={[arPdfStyles.hsnCellContainer, arPdfStyles.hsnCellContainerNoBorder, { width: "14%" }]}>
          <Text style={arPdfStyles.hsnCellText}>IGST{"\n"}Amount</Text>
        </View>
      </View>

      {displayEntries.map(([hsnCode, values], index) => (
        <View style={arPdfStyles.hsnRow} key={index}>
          <View style={[arPdfStyles.hsnCellContainer, { width: "15%" }]}>
            <Text style={arPdfStyles.hsnCellText}>{hsnCode}</Text>
          </View>
          <View style={[arPdfStyles.hsnCellContainer, { width: "17%" }]}>
            <Text style={[arPdfStyles.hsnCellText, arPdfStyles.hsnCellTextRight]}>
              {formatIndianNumber(values.taxable)}
            </Text>
          </View>
          <View style={[arPdfStyles.hsnCellContainer, { width: "10%" }]}>
            <Text style={arPdfStyles.hsnCellText}>{values.cgst !== 0 ? `${cgstSgstRate}%` : "-"}</Text>
          </View>
          <View style={[arPdfStyles.hsnCellContainer, { width: "12%" }]}>
            <Text style={[arPdfStyles.hsnCellText, arPdfStyles.hsnCellTextRight]}>
              {values.cgst !== 0 ? formatIndianNumber(values.cgst) : "-"}
            </Text>
          </View>
          <View style={[arPdfStyles.hsnCellContainer, { width: "10%" }]}>
            <Text style={arPdfStyles.hsnCellText}>{values.sgst !== 0 ? `${cgstSgstRate}%` : "-"}</Text>
          </View>
          <View style={[arPdfStyles.hsnCellContainer, { width: "12%" }]}>
            <Text style={[arPdfStyles.hsnCellText, arPdfStyles.hsnCellTextRight]}>
              {values.sgst !== 0 ? formatIndianNumber(values.sgst) : "-"}
            </Text>
          </View>
          <View style={[arPdfStyles.hsnCellContainer, { width: "10%" }]}>
            <Text style={arPdfStyles.hsnCellText}>{values.igst !== 0 ? `${igstRate}%` : "-"}</Text>
          </View>
          <View style={[arPdfStyles.hsnCellContainer, arPdfStyles.hsnCellContainerNoBorder, { width: "14%" }]}>
            <Text style={[arPdfStyles.hsnCellText, arPdfStyles.hsnCellTextRight]}>
              {values.igst !== 0 ? formatIndianNumber(values.igst) : "-"}
            </Text>
          </View>
        </View>
      ))}

      <View style={arPdfStyles.hsnTotalRow}>
        <View style={[arPdfStyles.hsnCellContainer, { width: "15%" }]}>
          <Text style={arPdfStyles.hsnCellText}>Total</Text>
        </View>
        <View style={[arPdfStyles.hsnCellContainer, { width: "17%" }]}>
          <Text style={[arPdfStyles.hsnCellText, arPdfStyles.hsnCellTextRight]}>
            {formatIndianNumber(totalTaxable)}
          </Text>
        </View>
        <View style={[arPdfStyles.hsnCellContainer, { width: "10%" }]}>
          <Text style={arPdfStyles.hsnCellText}></Text>
        </View>
        <View style={[arPdfStyles.hsnCellContainer, { width: "12%" }]}>
          <Text style={[arPdfStyles.hsnCellText, arPdfStyles.hsnCellTextRight]}>
            {totCgst !== 0 ? formatIndianNumber(totCgst) : "-"}
          </Text>
        </View>
        <View style={[arPdfStyles.hsnCellContainer, { width: "10%" }]}>
          <Text style={arPdfStyles.hsnCellText}></Text>
        </View>
        <View style={[arPdfStyles.hsnCellContainer, { width: "12%" }]}>
          <Text style={[arPdfStyles.hsnCellText, arPdfStyles.hsnCellTextRight]}>
            {totSgst !== 0 ? formatIndianNumber(totSgst) : "-"}
          </Text>
        </View>
        <View style={[arPdfStyles.hsnCellContainer, { width: "10%" }]}>
          <Text style={arPdfStyles.hsnCellText}></Text>
        </View>
        <View style={[arPdfStyles.hsnCellContainer, arPdfStyles.hsnCellContainerNoBorder, { width: "14%" }]}>
          <Text style={[arPdfStyles.hsnCellText, arPdfStyles.hsnCellTextRight]}>
            {totIgst !== 0 ? formatIndianNumber(totIgst) : "-"}
          </Text>
        </View>
      </View>
    </View>
  );
};

export const ArBankSignatureFooter = ({ company, footerText, docTypeLabel = "Document" }) => {
  const co = company || DEFAULT_COMPANY;
  const companyName = resolveCompanyName(co);

  return (
    <View wrap={false}>
      <View style={arPdfStyles.bottomSection}>
        <View style={arPdfStyles.bankSection}>
          <Text style={arPdfStyles.bankHeader}>Bank Details</Text>
          <View style={arPdfStyles.bankRow}>
            <Text style={arPdfStyles.bankLabel}>A/c Holder's Name:</Text>
            <Text style={arPdfStyles.bankValue}>
              {co.bank_account_name || co.accountHolderName || companyName}
            </Text>
          </View>
          <View style={arPdfStyles.bankRow}>
            <Text style={arPdfStyles.bankLabel}>Bank Name:</Text>
            <Text style={arPdfStyles.bankValue}>{co.bank_name || co.bankName || DEFAULT_COMPANY.bank_name}</Text>
          </View>
          <View style={arPdfStyles.bankRow}>
            <Text style={arPdfStyles.bankLabel}>A/c No.:</Text>
            <Text style={arPdfStyles.bankValue}>
              {co.bank_account_no || co.account_no || co.accountNo || DEFAULT_COMPANY.bank_account_no}
            </Text>
          </View>
          <View style={arPdfStyles.bankRowNoBorder}>
            <Text style={arPdfStyles.bankLabel}>Branch & IFS Code:</Text>
            <Text style={arPdfStyles.bankValue}>
              {co.bank_branch || co.branch_ifs || co.branchIfs || DEFAULT_COMPANY.bank_branch} &{" "}
              {co.bank_ifsc || co.ifsc || DEFAULT_COMPANY.bank_ifsc}
            </Text>
          </View>
          <Text style={arPdfStyles.gstNote}>
            As per GST rules 46 referred in section 31 of GST Act 2017 on "Tax Invoice, Credit and Debit Notes"{" "}
            {companyName} may representative with digital signature.
          </Text>
        </View>
      </View>

      <View style={arPdfStyles.signatureSection}>
        <View style={arPdfStyles.signatureBox}>
          <Text style={arPdfStyles.signatureText}>for {companyName}</Text>
          <Text style={arPdfStyles.signatureText}>Authorised Signatory</Text>
        </View>
      </View>

      <Text style={arPdfStyles.footerText}>{footerText || `This is a Computer Generated ${docTypeLabel}`}</Text>
    </View>
  );
};

export const ArPageNumber = () => (
  <Text
    style={arPdfStyles.pageNumber}
    render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
    fixed
  />
);

export const ArRemarksSection = ({ remarks, label = "Remarks" }) => {
  if (!remarks) return null;
  return (
    <View style={arPdfStyles.remarksSection} wrap={false}>
      <Text style={arPdfStyles.remarksText}>
        <Text style={arPdfStyles.remarksHeader}>{label}: </Text>
        {remarks}
      </Text>
    </View>
  );
};
